module.exports = __webpack_public_path__ + "img/7051.b3da3f98.svg";